import type { AreaCatalog } from '../area';
import type { groups as en } from '../en/groups';

export const groups = {
  // --- The Groups page ---
  'groups.list.title': 'Gruppen',
  'groups.list.none': 'das Wer',
  'groups.list.count': { one: '{count} Gruppe', other: '{count} Gruppen' },
  'groups.list.sortBy': 'Sortieren nach',
  'groups.list.sortLabel': 'Gruppen sortieren',
  'groups.sort.name': 'Name (A–Z)',
  'groups.sort.work': 'Meiste freigegebene Aufgaben',
  'groups.sort.members': 'Meiste Mitglieder',
  'groups.sort.recent': 'Zuletzt hinzugefügt',
  'groups.list.empty':
    'Noch keine Gruppen. Eine Gruppe ist ein WER - sie hat keine eigenen Aufgaben; du gibst Aufgaben für sie frei, und sie erscheinen auf ihrem Board. Erstelle eine, um anzufangen.',
  'groups.count.members': { one: '{count} Mitglied', other: '{count} Mitglieder' },
  'groups.count.sharedItems': {
    one: '{count} freigegebene Aufgabe',
    other: '{count} freigegebene Aufgaben',
  },
  'groups.count.views': {
    one: '{count} Board oder Ansicht',
    other: '{count} Boards und Ansichten',
  },
  'groups.count.open': '{count} offen',

  // --- A group's page ---
  'groups.page.definition':
    'Eine Gruppe besteht aus Personen. Sie hat keine eigenen Aufgaben: Sie kann für Aufgaben verantwortlich oder zuständig sein, und Boards, Ansichten und Aufgaben werden für sie freigegeben.',
  'groups.page.description': 'Beschreibung',
  'groups.page.descriptionPlaceholder': 'Wofür ist diese Gruppe da?',
  'groups.page.views': 'Boards und Ansichten',
  'groups.page.noViews':
    'Kein Board und keine Ansicht ist mit dieser Gruppe geteilt. Ein Board oder eine Ansicht erreicht sie, sobald die Gruppe zum Personenkreis gehört.',
  'groups.viewKind.map': 'Landkarte',
  'groups.viewKind.board': 'Board',
  'groups.viewKind.lens': 'Ansicht',
  'groups.page.work': 'Aufgaben',
  'groups.page.nothingOpen':
    'Nichts offen. Alle für diese Gruppe freigegebenen Aufgaben sind abgeschlossen.',
  'groups.page.noWork': 'Für diese Gruppe sind noch keine Aufgaben freigegeben.',
  'groups.page.moreOpen': '{count} weitere offen',
  'groups.page.done': '{count} abgeschlossen',
  'groups.page.cancelled': '{count} abgebrochen',
  'groups.page.seating': 'Wer diese Gruppe direkt einsetzen darf',

  // --- Membership ---
  'groups.members.title': 'Mitglieder',
  'groups.parents.title': 'Übergeordnete Gruppen',
  'groups.role.option.viewer': 'Betrachtende',
  'groups.role.option.member': 'Mitglied',
  'groups.role.option.owner': 'Verwaltende',
  'groups.role.hint.viewer': 'kann sehen',
  'groups.role.hint.member': 'kann arbeiten',
  'groups.role.hint.owner': 'kann verwalten',
  'groups.role.viewer': 'Betrachtende',
  'groups.role.member': 'Mitglied',
  'groups.role.owner': 'Verwaltende',
  'groups.rank.owners': 'Verwaltende',
  'groups.rank.members': 'Mitglieder',
  'groups.rank.viewers': 'Betrachtende',
  'groups.pending.asksToNest': 'möchte Untergruppe werden · {role}',
  'groups.pending.askedToJoin': 'eingeladen · {role}',
  'groups.pending.pending': 'ausstehend · {role}',
  'groups.pending.accept': 'Annehmen',
  'groups.pending.decline': 'Ablehnen',
  'groups.pending.withdraw': 'Zurückziehen',
  'groups.add.member': 'Person oder Gruppe hinzufügen',
  'groups.add.parent': 'Einer Gruppe unterordnen',
  'groups.add.cancel': 'Abbrechen',
  'groups.add.memberPlaceholder': 'Personen und Gruppen hinzufügen…',
  'groups.add.parentPlaceholder': 'Einer Gruppe unterordnen…',
  'groups.add.noParent': 'Keine andere Gruppe zum Unterordnen.',
  'groups.source.direct': 'direkt',
  'groups.source.via': 'über {name}',
  'groups.source.nested': 'Untergruppe',
  'groups.member.roleFor': 'Rolle für {name}',
  'groups.member.directRole':
    'Die direkte Rolle hier (über eine Untergruppe hat die Person die Rolle {role})',
  'groups.member.remove': '{name} entfernen',
  'groups.parent.leave': '{name} verlassen',
  'groups.members.empty': 'Noch niemand.',
  'groups.parents.empty': 'Keiner Gruppe untergeordnet - diese Gruppe steht für sich.',
} as const satisfies AreaCatalog<typeof en>;
